// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/antd@6.6.5_moment@2.30.1_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/antd/dist/reset.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js!../../node_modules/.pnpm/feathers-react@0.5.5_prop-types@15.8.1_react-dom@19.3.0_react@19.3.0__react@19.3.0/node_modules/feathers-react/dist/style.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
}
body {
  background-color: #f5f8fd;
}
h1,
h2,
h3 {
  font-family: 'Inter', sans-serif;
  color: #617C9D;
  font-weight: 700;
}
h2,
h3 {
  font-weight: 400;
}
body,
h4,
h5,
h6,
p {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.ReactModal__Content {
  background-color: #f5f8fd !important;
}
.ReactModal__Body--open {
  overflow: hidden;
}
svg {
  display: inline-block;
  vertical-align: middle;
}
.ant-picker {
  width: 100%;
}
.ant-menu-inline-collapsed {
  width: auto;
}
.ant-menu-inline-collapsed > .ant-menu-submenu > .ant-menu-submenu-title {
  padding: 0 !important;
}
.ant-menu-inline,
.ant-menu-inline-collapsed {
  background: none;
  border: none;
}
.ant-menu-inline > .ant-menu-item-divider,
.ant-menu-inline-collapsed > .ant-menu-item-divider {
  background: none;
  margin: 1rem 0;
}
.ant-menu-inline .ant-menu-item,
.ant-menu-inline-collapsed .ant-menu-item {
  color: #8282A1;
  font-size: 1.25em;
  font-weight: 400;
  height: auto;
  line-height: 2.5;
  padding: 0 !important;
}
.ant-menu-inline .ant-menu-item-selected,
.ant-menu-inline-collapsed .ant-menu-item-selected {
  background: none !important;
  color: #4B4DF1;
}
.ant-menu-inline .ant-menu-item-selected::after,
.ant-menu-inline-collapsed .ant-menu-item-selected::after {
  display: none;
}
.ant-menu-inline .ant-menu-item:active,
.ant-menu-inline-collapsed .ant-menu-item:active {
  background: none;
}
.ant-menu-inline .ant-menu-item:empty,
.ant-menu-inline-collapsed .ant-menu-item:empty {
  display: none;
}
.ant-menu-inline .ant-menu-sub,
.ant-menu-inline-collapsed .ant-menu-sub {
  font-size: 0.8em;
  padding-left: 3.75em;
}
.ant-menu-inline .ant-menu-submenu-title,
.ant-menu-inline-collapsed .ant-menu-submenu-title {
  color: #8282A1;
  font-size: 1.25em;
  font-weight: 400;
  height: auto;
  line-height: 2.5;
  padding: 0 !important;
}
.ant-menu-inline .ant-menu-submenu-title::after,
.ant-menu-inline-collapsed .ant-menu-submenu-title::after {
  right: 0;
  top: 50%;
  transform: translateY(-50%) scale(0.75);
}
.ant-menu-inline .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title::after,
.ant-menu-inline-collapsed .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title::after {
  transform: translateY(-50%) rotate(180deg) scale(0.75);
}
.ant-menu-inline .ant-menu-submenu > .ant-menu,
.ant-menu-inline-collapsed .ant-menu-submenu > .ant-menu {
  background: none;
}
.ant-menu-inline .ant-menu-submenu > .ant-menu .ant-menu-item,
.ant-menu-inline-collapsed .ant-menu-submenu > .ant-menu .ant-menu-item {
  line-height: 2;
  height: auto;
}
.ant-menu-inline svg,
.ant-menu-inline-collapsed svg {
  margin-right: 1em;
}
.ant-form-item,
.ant-legacy-form-item {
  text-align: left;
}
.ant-form-item-required::before,
.ant-legacy-form-item-required::before {
  display: none !important;
}
.ant-form-item-required::after,
.ant-legacy-form-item-required::after {
  display: inline-block !important;
  margin-left: 4px !important;
  content: "*" !important;
  font-family: SimSun;
  line-height: 1;
  font-size: 14px;
  color: #F44336;
}
.ant-form-item-label,
.ant-legacy-form-item-label {
  text-align: left;
  width: 100%;
}
.ant-form-item-label label,
.ant-legacy-form-item-label label {
  color: #848A9E;
  text-transform: uppercase;
  font-size: 0.9em;
  letter-spacing: 0.1em;
  font-weight: 300;
}
.ant-form-item-control.has-success::after,
.ant-legacy-form-item-control.has-success::after,
.ant-form-item-control.has-error::after,
.ant-legacy-form-item-control.has-error::after,
.ant-form-item-control.has-warning::after,
.ant-legacy-form-item-control.has-warning::after {
  line-height: 3rem;
}
.ant-input-affix-wrapper .ant-input,
.ant-input-affix-wrapper .ant-input:hover,
.ant-input-affix-wrapper .ant-input:focus {
  height: auto !important;
  box-shadow: none;
}
.ant-input,
.ant-input-number,
.ant-picker,
.ant-select,
.ant-input-affix-wrapper {
  background-color: white !important;
  border-color: white !important;
  box-shadow: 0 4px 12px 0 rgba(74, 144, 226, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  height: 2.25rem !important;
  border-radius: 0.25rem;
}
.ant-input:-webkit-autofill,
.ant-input-number:-webkit-autofill,
.ant-picker:-webkit-autofill,
.ant-select:-webkit-autofill,
.ant-input-affix-wrapper:-webkit-autofill {
  box-shadow: 0 4px 12px 0 rgba(74, 144, 226, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 500px white;
  outline: none;
}
.ant-input:-webkit-autofill:focus,
.ant-input-number:-webkit-autofill:focus,
.ant-picker:-webkit-autofill:focus,
.ant-select:-webkit-autofill:focus,
.ant-input-affix-wrapper:-webkit-autofill:focus,
.ant-input:-webkit-autofill:hover,
.ant-input-number:-webkit-autofill:hover,
.ant-picker:-webkit-autofill:hover,
.ant-select:-webkit-autofill:hover,
.ant-input-affix-wrapper:-webkit-autofill:hover {
  box-shadow: 0 4px 12px 0 rgba(73, 141, 225, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.15), inset 0 0 0 500px white;
  outline: none;
}
.ant-input-number,
.ant-input-number-number,
.ant-picker-number,
.ant-select-number,
.ant-input-affix-wrapper-number {
  align-items: center;
  display: flex;
  width: auto;
}
.ant-input-number-handler-wrap,
.ant-input-number-number-handler-wrap,
.ant-picker-number-handler-wrap,
.ant-select-number-handler-wrap,
.ant-input-affix-wrapper-number-handler-wrap,
.ant-input-number-handler-up,
.ant-input-number-number-handler-up,
.ant-picker-number-handler-up,
.ant-select-number-handler-up,
.ant-input-affix-wrapper-number-handler-up,
.ant-input-number-handler-down,
.ant-input-number-number-handler-down,
.ant-picker-number-handler-down,
.ant-select-number-handler-down,
.ant-input-affix-wrapper-number-handler-down {
  border-color: #f5f8fd;
}
.ant-input:focus,
.ant-input-number:focus,
.ant-picker:focus,
.ant-select:focus,
.ant-input-affix-wrapper:focus,
.ant-input:hover,
.ant-input-number:hover,
.ant-picker:hover,
.ant-select:hover,
.ant-input-affix-wrapper:hover {
  background: #FFFFFF;
  border-color: white;
  box-shadow: 0 4px 12px 0 rgba(73, 141, 225, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.ant-input-lg,
.ant-input-number-lg,
.ant-picker-lg,
.ant-select-lg,
.ant-input-affix-wrapper-lg {
  height: 3rem !important;
}
.ant-input[disabled],
.ant-input-number[disabled],
.ant-picker[disabled],
.ant-select[disabled],
.ant-input-affix-wrapper[disabled],
.ant-input-disabled,
.ant-input-number-disabled,
.ant-picker-disabled,
.ant-select-disabled,
.ant-input-affix-wrapper-disabled {
  border: 1px dashed rgba(0, 0, 0, 0.05);
  opacity: 0.5;
}
.ant-input-group-lg .ant-input,
.ant-input-group-lg .ant-input-number,
.ant-input-group-lg .ant-picker,
.ant-input-group-lg .ant-select,
.ant-input-group-lg .ant-input-affix-wrapper {
  height: 3rem !important;
}
.ant-input--focus-only:not(:focus),
.ant-input-number--focus-only:not(:focus),
.ant-picker--focus-only:not(:focus),
.ant-select--focus-only:not(:focus),
.ant-input-affix-wrapper--focus-only:not(:focus) {
  background: none;
  border-color: transparent;
  box-shadow: none;
  cursor: pointer;
  padding: 0;
}
.ant-input--flat,
.ant-input-number--flat,
.ant-picker--flat,
.ant-select--flat,
.ant-input-affix-wrapper--flat {
  border-radius: 0;
  box-shadow: 0 1px 0 #F2F2F2;
  padding-left: 0;
  padding-right: 0;
}
.ant-input--flat:hover,
.ant-input-number--flat:hover,
.ant-picker--flat:hover,
.ant-select--flat:hover,
.ant-input-affix-wrapper--flat:hover,
.ant-input--flat:focus,
.ant-input-number--flat:focus,
.ant-picker--flat:focus,
.ant-select--flat:focus,
.ant-input-affix-wrapper--flat:focus {
  border-radius: 0;
  box-shadow: 0 1px 0 #4B4DF1;
}
.has-error .ant-input--flat,
.has-error .ant-input-number--flat,
.has-error .ant-picker--flat,
.has-error .ant-select--flat,
.has-error .ant-input-affix-wrapper--flat {
  border-color: transparent;
  box-shadow: 0 1px 0 #F2F2F2;
}
.has-error .ant-input--flat:hover,
.has-error .ant-input-number--flat:hover,
.has-error .ant-picker--flat:hover,
.has-error .ant-select--flat:hover,
.has-error .ant-input-affix-wrapper--flat:hover,
.has-error .ant-input--flat:focus,
.has-error .ant-input-number--flat:focus,
.has-error .ant-picker--flat:focus,
.has-error .ant-select--flat:focus,
.has-error .ant-input-affix-wrapper--flat:focus {
  border-color: transparent !important;
  box-shadow: 0 1px 0 #4B4DF1;
}
.ant-input--password-confirm,
.ant-input-number--password-confirm,
.ant-picker--password-confirm,
.ant-select--password-confirm,
.ant-input-affix-wrapper--password-confirm {
  mask-image: linear-gradient(to left, transparent, white 4em);
  padding: 0.75em 0.25em;
  transform: translateX(4em);
  -webkit-mask-image: linear-gradient(to left, transparent, white 4em);
}
.ant-input--password-confirm .ant-input,
.ant-input-number--password-confirm .ant-input,
.ant-picker--password-confirm .ant-input,
.ant-select--password-confirm .ant-input,
.ant-input-affix-wrapper--password-confirm .ant-input {
  border-radius: 1.75em;
  padding-right: 4em;
}
.ant-select {
  align-items: center;
  display: flex;
  width: 100%;
}
.ant-select-focused {
  box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);
}
.ant-select-content {
  display: flex;
  flex-wrap: wrap;
}
.ant-select-multiple {
  padding: 0;
  height: auto;
}
.ant-select-multiple .ant-select-content {
  align-items: center;
  display: flex;
  height: inherit;
  margin: 0;
}
.ant-select-multiple .ant-select-selection-item {
  margin: 0.125em;
}
.ant-select-multiple .ant-select-placeholder {
  padding: 0 0.5em;
}
.ant-select-lg {
  height: 3rem;
}
.ant-badge-count {
  background-color: #4B4DF1;
  cursor: default;
  font-size: 0.75em;
  height: 1rem;
  min-width: 1rem;
  line-height: 1rem;
  padding: 0 0.25rem;
  right: 0;
  top: 0;
  transform: translate(25%, -25%);
}
.ant-badge .ant-btn-flat:not(:only-child):not(:hover) {
  background: rgba(255, 255, 255, 0.5);
  box-shadow: rgba(50, 50, 93, 0.05) 0 0.0625rem 0.25rem, rgba(0, 0, 0, 0.02) 0 0.0625rem 0;
}
.ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
  border-color: transparent;
}
.ant-input-affix-wrapper .ant-input-prefix {
  left: 1rem;
  opacity: 0.5;
}
.ant-radio-group {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 1.25em;
  padding: 0.125em;
}
.ant-radio-group .ant-radio-button-wrapper {
  background: none;
  border: none;
  border-radius: 1.25em;
}
.ant-radio-group .ant-radio-button-wrapper::before,
.ant-radio-group .ant-radio-button-wrapper::after {
  display: none;
}
.ant-radio-group .ant-radio-button-wrapper-checked {
  background-color: #4B4DF1;
  color: white;
}
.ant-radio-group--inverted {
  background-color: rgba(0, 0, 0, 0.1);
}
.ant-radio-group--inverted .ant-radio-button-wrapper {
  color: white;
}
.ant-radio-group--inverted .ant-radio-button-wrapper-checked {
  background-color: white;
  color: #4B4DF1;
}
.ant-input-group {
  align-items: center;
  display: flex;
}
.ant-input-group .ant-btn:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.ant-input-group .ant-input {
  float: none;
  flex-grow: 1;
  width: auto;
}
.ant-input-group .ant-input-group-addon {
  flex-grow: 1;
}
.ant-tag {
  align-items: center;
  background-color: #DBE8F9;
  border: none;
  border-radius: 0.8rem;
  display: inline-flex;
  height: 1.625rem;
  line-height: 1;
  margin: 0.25rem 0.5rem 0.25rem 0;
  padding: 0 0.5rem;
}
.ant-tag-text {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.75rem;
}
.ant-tag svg {
  background-color: rgba(0, 0, 0, 0.1);
  border: 0.25rem solid transparent;
  border-radius: 50%;
  margin-left: -0.35rem;
  margin-right: 0.25rem;
}
.ant-dropdown-placement-topRight {
  left: auto !important;
  right: calc(25em + 7vw) !important;
}
.ant-dropdown-menu {
  padding: 0.5rem 0;
  box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);
}
.ant-dropdown-menu-item {
  border-radius: 0 !important;
  padding: 0.75rem 1rem;
}
.ant-dropdown-menu-item-group-title {
  font-size: 0.65rem;
  padding: 1rem 1rem 0;
}
.ant-dropdown-menu-item-group-list {
  margin: 0;
}
.ant-dropdown-menu-item-divider {
  background-color: #FAFAFA;
}
.ant-dropdown-menu-item svg,
.ant-dropdown-menu-item i {
  margin-right: 0.75rem;
}
.ant-dropdown-menu-item svg {
  transform: translateY(-0.0625rem);
}
.ant-dropdown-menu-item--info {
  background-color: rgba(75, 77, 241, 0.05);
  color: #617C9D;
  font-size: 0.85em;
  margin-top: -0.5rem;
  padding: 0.25em 1.125em;
  pointer-events: none;
}
.ant-btn {
  align-items: center;
  background-color: transparent;
  border-radius: 1.125rem;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  min-height: 2.25rem;
  padding: 0 1rem;
  text-transform: uppercase;
}
.ant-btn:hover,
.ant-btn:focus {
  background-color: transparent;
}
.ant-btn > .anticon {
  font-size: 1.125em;
  margin-right: 0.5em;
  display: block;
}
.ant-btn-sm {
  border-radius: 1rem;
  min-height: 2rem;
  padding: 0 0.75rem;
}
.ant-btn-lg {
  border-radius: 1.5rem;
  font-size: 1rem;
  font-weight: 300;
  min-height: 3rem;
  padding: 0 1.5rem;
}
.ant-btn-danger {
  background-image: linear-gradient(to bottom right, #F44336, #F4367C) !important;
  border-color: transparent;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  color: white !important;
}
.ant-btn-danger:hover {
  background-image: linear-gradient(to bottom right, #F44336, #F4367C) !important;
  border-color: transparent;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1), 0 2px 16px 0 rgba(244, 67, 54, 0.2);
  color: white !important;
}
.ant-btn-flat {
  border-color: transparent;
  box-shadow: none;
}
.ant-btn-flat:hover,
.ant-btn-flat:focus {
  background: white !important;
  border-color: transparent !important;
  box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15) !important;
}
.ant-btn-flat[disabled] {
  background: none;
  border-color: #d0d0d0;
}
.ant-btn-flat[disabled]:hover {
  background: none;
  border-color: #d0d0d0;
  box-shadow: none;
}
.ant-btn-flat + .ant-btn-flat {
  margin-left: 1em;
}
.ant-btn-pressed {
  background: rgba(0, 0, 0, 0.05);
  border-color: transparent;
  box-shadow: inset 0 0.0625rem 0.0625rem rgba(0, 0, 0, 0.125);
  color: #4B4DF1;
}
.ant-btn-pressed:hover {
  background: rgba(0, 0, 0, 0.05);
  border-color: transparent;
}
.ant-btn-pressed-primary {
  background: linear-gradient(to top, #3db778, #36a46c);
  border: none;
  box-shadow: inset 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.25);
  color: rgba(255, 255, 255, 0.9);
}
.ant-btn-pressed-primary[data-close-text] span:last-child {
  font-size: 0;
  transition: all 500ms;
}
.ant-btn-pressed-primary[data-close-text]::before {
  background: none;
  content: attr(data-close-text) !important;
  display: block !important;
  font-size: 0.8rem;
  margin-right: 1em;
  opacity: 1;
  position: static;
  transition: all 500ms;
  z-index: 2;
}
.ant-btn-pressed-primary[data-close-text] svg {
  margin-right: 0;
}
.ant-btn-pressed-primary .icon-plus {
  transform: rotate(45deg);
  transition: transform 250ms;
  transition-delay: 125ms;
  will-change: transform;
}
.ant-btn-pressed-primary:hover {
  background: linear-gradient(to top, #3db778, #36a46c);
  box-shadow: inset 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.25);
  border: none;
  color: rgba(255, 255, 255, 0.9);
}
.ant-btn-primary:not(.ant-btn-background-ghost),
.ant-btn-primary-alt {
  background: linear-gradient(to bottom right, #81E390, #4AC385);
  border: none;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  color: white;
}
.ant-btn-primary:not(.ant-btn-background-ghost)[data-close-text] span:last-child,
.ant-btn-primary-alt[data-close-text] span:last-child {
  transition: all 500ms;
}
.ant-btn-primary:not(.ant-btn-background-ghost)[data-close-text]::before,
.ant-btn-primary-alt[data-close-text]::before {
  background: none;
  content: attr(data-close-text) !important;
  display: block !important;
  font-size: 0;
  position: static !important;
  transform: none !important;
  transition: all 500ms;
}
.ant-btn-primary:not(.ant-btn-background-ghost):hover,
.ant-btn-primary-alt:hover,
.ant-btn-primary:not(.ant-btn-background-ghost):focus,
.ant-btn-primary-alt:focus {
  background: linear-gradient(to bottom right, #81E390, #4AC385);
  border: none !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 2px 16px 0 rgba(139, 195, 74, 0.25);
  color: white !important;
}
.ant-btn-primary:not(.ant-btn-background-ghost)[disabled],
.ant-btn-primary-alt[disabled] {
  background: linear-gradient(to bottom right, #EEE, #DDD);
  box-shadow: none;
  pointer-events: none;
}
.ant-input-group-lg .ant-btn-primary:not(.ant-btn-background-ghost),
.ant-input-group-lg .ant-btn-primary-alt {
  border-radius: 0 1.5rem 1.5rem 0;
  box-shadow: 0 4px 12px 0 rgba(74,144,226,0.08), 0 1px 2px 0 rgba(0,0,0,0.10);
  min-height: 3rem;
  padding: 0 2rem 0 1.5rem;
}
.ant-input-group-lg .ant-btn-primary:not(.ant-btn-background-ghost):hover,
.ant-input-group-lg .ant-btn-primary-alt:hover {
  box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);
}
.ant-btn-primary:not(.ant-btn-background-ghost) .icon-plus,
.ant-btn-primary-alt .icon-plus {
  transition-delay: 125ms;
  transition: transform 250ms;
  will-change: transform;
}
.ant-btn-primary-alt {
  background: linear-gradient(to bottom right, #9293f7, #4B4DF1);
}
.ant-btn-primary-alt:focus,
.ant-btn-primary-alt:hover {
  background: linear-gradient(to bottom right, #9293f7, #4B4DF1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 2px 16px 0 rgba(96, 74, 195, 0.25);
}
.ant-btn-loading .anticon-loading {
  height: 1em;
  margin-right: 0.25em;
  width: 1em;
}
.ant-btn svg {
  margin-right: 0.75rem;
  margin-left: -0.25rem;
}
.ant-btn svg + span {
  margin-left: -0.25rem;
  vertical-align: middle;
}
.ant-btn svg:only-child {
  margin: 0 -0.35rem;
}
.ant-card-head {
  background: none;
  border-color: #FAFAFA;
}
.ant-card-head-title {
  color: #4B4DF1;
  font-weight: 300;
}
.ant-steps-status-warn .ant-steps-item-icon {
  background-color: #FFCA28;
  border-color: #f4b800;
  color: white;
}
.ant-steps-status-warn .ant-steps-item-icon .ant-steps-icon {
  color: currentColor;
}
.ant-steps:not(.ant-steps-horizontal) .ant-steps-item-icon {
  background-color: transparent;
  height: 2em !important;
  width: 2em !important;
}
.ant-steps:not(.ant-steps-horizontal) .ant-steps-item-icon > .ant-steps-icon {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
.ant-steps:not(.ant-steps-horizontal) .ant-steps-item-icon svg {
  display: inline-block;
  margin: 0;
}
.ant-steps:not(.ant-steps-horizontal) .ant-steps-title {
  background-color: transparent;
}
.ant-steps:not(.ant-steps-horizontal) .ant-steps-description::first-letter {
  text-transform: uppercase;
}
.ant-collapse {
  margin-bottom: 2em;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-header:hover {
  background-color: rgba(75, 77, 241, 0.05);
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-panel {
  background-color: rgba(75, 77, 241, 0.02);
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: rgba(0, 0, 0, 0.05);
  position: relative;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-panel::after,
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-panel::before {
  content: '';
  height: 0.25em;
  left: 0;
  opacity: 0.025;
  position: absolute;
  right: 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-panel::after {
  background-image: linear-gradient(to bottom, transparent, black);
  bottom: 0;
}
.ant-collapse-borderless > .ant-collapse-item > .ant-collapse-panel::before {
  background-image: linear-gradient(to top, transparent, black);
  top: 0;
}
.ant-collapse-borderless > .ant-collapse-item-active > .ant-collapse-header:hover {
  background-color: transparent;
}
.ant-collapse-borderless + .ant-collapse-borderless {
  margin-top: 2em;
}
.ant-collapse--cards {
  background: none;
  border: none;
  border-radius: 0;
}
.ant-collapse--cards > .ant-collapse-item:not(.ant-collapse-item-disabled) > .ant-collapse-header:active {
  background: none;
}
.ant-collapse--cards .ant-collapse-header {
  line-height: 2.5 !important;
  padding-left: 2.5em !important;
}
.ant-collapse--cards .ant-collapse-header .ant-collapse-arrow {
  display: none !important;
}
.ant-collapse--cards .ant-collapse-panel {
  border-top-color: rgba(0, 0, 0, 0.025);
}
.ant-collapse--cards .ant-collapse-body {
  padding: 1em;
}
.ant-collapse--cards .ant-collapse-item {
  background: white;
  border-bottom: none;
  box-shadow: 0 4px 12px 0 rgba(74, 144, 226, 0.08), 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  transition: margin 250ms, transform 250ms;
}
.ant-collapse--cards .ant-collapse-item-active {
  border-radius: 0.25em !important;
  box-shadow: 0 4px 12px 0 rgba(73, 141, 225, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  margin: 1em -0.5em;
}
.ant-collapse--cards .ant-collapse-item-active + .ant-collapse-item {
  border-top-left-radius: 0.25em;
  border-top-right-radius: 0.25em;
}
.ant-collapse--cards .ant-collapse-item-disabled .ant-collapse-header {
  background: none;
}
.ant-collapse--cards .ant-collapse-item:first-child:not(.ant-collapse-item-active) {
  border-radius: 0.25em 0.25em 0 0;
}
.ant-collapse--cards .ant-collapse-item:last-child:not(.ant-collapse-item-active) {
  border-radius: 0 0 0.25em 0.25em;
}
.ant-collapse--cards .ant-collapse-item:only-child:not(.ant-collapse-item-active) {
  border-radius: 0.25em;
}
.ant-layout {
  background: none;
}
@media (max-width: 480px) {
  .ant-layout {
    overflow: hidden;
  }
}
@media (max-width: 480px) {
  .ant-layout-content {
    min-width: 100vw;
  }
}
@media (max-width: 480px) {
  .ant-layout.ant-layout-has-sider .ant-layout-sider {
    background-color: rgba(0, 0, 0, 0.025);
    box-shadow: inset -0.125em 0 0.125em rgba(0, 0, 0, 0.05), inset -0.25em 0 0.5em rgba(0, 0, 0, 0.05);
    min-height: calc(100vh - 4.75em);
  }
}
.ant-layout.ant-layout-has-sider.ant-layout-reversed {
  flex-direction: row-reverse;
}
@media (max-width: 480px) {
  .ant-layout.ant-layout-has-sider.ant-layout-reversed .ant-layout-sider {
    box-shadow: inset 0.125em 0 0.125em rgba(0, 0, 0, 0.05), inset 0.25em 0 0.5em rgba(0, 0, 0, 0.05);
  }
}
.ant-layout-reversed .ant-layout-sider-zero-width-trigger {
  border-radius: 4px 0 0 4px;
  position: fixed;
  right: 0;
  top: 8em;
}
.ant-layout-default .ant-layout-sider-zero-width-trigger {
  background: none;
  color: #666;
  left: 0;
  position: fixed;
  right: auto;
  top: 0.75em;
  z-index: 20;
}
.ant-layout-reversed .ant-layout-sider-collapsed {
  max-height: 0;
  padding: 5em 0;
}
.ant-alert {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-left-width: 0.25em;
  border-radius: 0 0.25em 0.25em 0;
}
.ant-alert-with-description .ant-alert-title {
  font-size: 1.5em;
  font-weight: 300;
  margin-bottom: 0.5em;
}
.ant-alert-title:empty {
  display: none;
}
.ant-alert-info,
.ant-alert-error,
.ant-alert-warning,
.ant-alert-success {
  background: white;
}
.ant-alert-info {
  border-left-color: #42A5F5;
}
.ant-alert-error {
  border-left-color: #F44336;
}
.ant-alert-warning {
  border-left-color: #FFCA28;
}
.ant-alert-success {
  border-left-color: #9CCC65;
}
.ant-table {
  background: white;
  border-radius: 0.5em;
  box-shadow: 0 4px 12px 0 rgba(73, 141, 225, 0.15), 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}
@media (max-width: 480px) {
  .ant-table {
    border-radius: 0;
    margin-left: -1em;
    margin-right: -1em;
  }
}
.ant-table-thead > tr > th,
.ant-table-tbody > tr > th,
.ant-table-thead > tr td,
.ant-table-tbody > tr td {
  font-size: 0.9em;
  padding-left: 1.5em;
  padding-right: 1.5em;
}
.ant-table-thead > tr > th,
.ant-table-thead > tr > td {
  background-color: #FDFDFD;
  border-bottom: 1px solid #F2F2F2;
  color: #999;
  font-weight: 400;
}
.ant-table-thead > tr > th:first-child,
.ant-table-thead > tr > td:first-child {
  border-radius: 0.26em 0 0 0;
}
.ant-table-thead > tr > th:last-child,
.ant-table-thead > tr > td:last-child {
  border-radius: 0 0.26em 0 0;
}
.ant-table-tbody > tr > td {
  border-color: #FAFAFA;
  cursor: pointer;
}
.ant-table-tbody > tr.ant-table-expanded-row:hover > td {
  background-color: #FEFEFE;
  cursor: default;
}
.ant-table-tbody > tr:last-child > td {
  border-bottom: none;
}
.ant-table-expanded-row td,
.ant-table-expanded-row:hover td {
  background-color: #FEFEFE;
}
.ant-table-row-expand-icon {
  pointer-events: none;
}
.ant-table-footer {
  background-color: #FCFCFC;
  color: rgba(0, 0, 0, 0.35);
  position: relative;
}
.ant-table-footer::after,
.ant-table-footer::before {
  background: linear-gradient(to bottom, black, transparent);
  content: '';
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.ant-table-footer::after {
  height: 1em;
  opacity: 0.0125;
}
.ant-table-footer::before {
  height: 0.25em;
  opacity: 0.025;
}
.ant-switch-label {
  display: inline-block;
  margin-left: 1em;
  vertical-align: middle;
}
@media (min-width: 768px) {
  .ant-popover {
    max-width: 25vw;
  }
}
.ant-popover-container {
  box-shadow: none !important;
}
@supports (backdrop-filter: blur(.5em)) {
  .ant-tooltip-inner {
    backdrop-filter: blur(0.5em);
  }
}
.ReactModal__Body--open #root,
body[style="overflow: hidden;"] #root {
  filter: blur(5px);
  transform: translate3d(0, 0, 0);
}
.sidebar-modal {
  position: absolute;
  overflow-y: auto;
  right: 0;
  transform: translateX(100%) !important;
  width: 50%;
}
.sidebar-modal--opened {
  transform: translateX(0) !important;
}
.sidebar-modal--closing {
  transform: translateX(100%) !important;
}
.CodeMirror {
  height: 700px !important;
}
.recharts-text {
  fill: currentColor;
}
.recharts-cartesian-grid line {
  opacity: 0.125;
  stroke: currentColor;
  stroke-dasharray: 0.125em;
}
.recharts-cartesian-axis line {
  opacity: 0.25;
  stroke: currentColor;
}
.ant-legacy-form-item .ReactPasswordStrength {
  align-items: center;
  border: none;
  display: flex;
  font-size: inherit;
  padding-right: 2em !important;
  position: relative;
}
.ant-legacy-form-item .ReactPasswordStrength-input {
  border: none;
  flex-grow: 1;
  font-size: inherit;
  height: 100%;
  padding: 0 0.25em;
  width: auto;
}
.ant-legacy-form-item .ReactPasswordStrength-input::placeholder {
  color: #999;
}
.ant-legacy-form-item .ReactPasswordStrength-strength-desc {
  font-size: 0.75em;
  padding: 0;
  pointer-events: none;
  position: static;
  white-space: nowrap;
}
.ant-legacy-form-item .ReactPasswordStrength-strength-bar {
  border-radius: 0 0 0 0.25em;
  bottom: 0;
  left: 0;
  position: absolute;
  top: auto;
}
.ant-legacy-form-item .ReactPasswordStrength.is-strength-4 .ReactPasswordStrength-strength-bar {
  border-radius: 0 0 0.25em 0.25em;
  width: 100% !important;
}
.fr-table-wrapper {
  box-shadow: 0 4px 12px 0 rgba(74,144,226,0.08), 0 1px 2px 0 rgba(0,0,0,0.10);
  font-size: 1.125em;
}
.fr-table-content {
  hyphens: auto;
  overflow-wrap: break-word;
}
[data-tooltip]:not([data-tooltip=""]) {
  position: relative;
}
[data-tooltip]:not([data-tooltip=""])::before,
[data-tooltip]:not([data-tooltip=""])::after {
  pointer-events: none;
  will-change: transform;
  transition: transform 250ms, opacity 250ms;
  opacity: 0;
}
[data-tooltip]:not([data-tooltip=""]):hover::before,
[data-tooltip]:not([data-tooltip=""]):hover::after {
  opacity: 1;
}
[data-tooltip]:not([data-tooltip=""]):hover::before {
  transform: translate(-50%, -0.5rem);
}
[data-tooltip]:not([data-tooltip=""]):hover::after {
  transform: translate(-50%, -1rem);
}
[data-tooltip]:not([data-tooltip=""])::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, -0.5rem);
  background: rgba(0, 0, 0, 0.75);
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  color: white;
  z-index: 100;
  text-transform: none;
}
[data-tooltip]:not([data-tooltip=""])::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0.5rem 0.5rem 0 0.5rem;
  border-color: rgba(0, 0, 0, 0.75) transparent transparent transparent;
}
`, "",{"version":3,"sources":["webpack://./app/app.less"],"names":[],"mappings":"AAcA;EACE,eAAA;EACA,kCAAA;EACA,mCAAA;AAXF;AAcA;EACE,yBAAA;AAZF;AAeA;;;EACE,gCAAA;EACA,cAAA;EACA,gBAAA;AAXF;AAcA;;EACE,gBAAA;AAXF;AAcA;;;;;EACE,wIAAA;AARF;AAYE;EACE,oCAAA;AAVJ;AAaE;EACE,gBAAA;AAXJ;AAeA;EACE,qBAAA;EACA,sBAAA;AAbF;AAgBA;EACE,WAAA;AAdF;AAkBE;EACE,WAAA;AAhBJ;AAeE;EAII,qBAAA;AAhBN;AAsBE;;EACE,gBAAA;EACA,YAAA;AAnBJ;AAiBE;;EAKI,gBAAA;EACA,cAAA;AAlBN;AAsBM;;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AAnBR;AAqBQ;;EACE,2BAAA;EACA,cAAA;AAlBV;AAoBU;;EACE,aAAA;AAjBZ;AAqBQ;;EACE,gBAAA;AAlBV;AAqBQ;;EACE,aAAA;AAlBV;AAsBM;;EACE,gBAAA;EACA,oBAAA;AAnBR;AAuBQ;;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;AApBV;AAsBU;;EACE,QAAA;EACA,QAAA;EACA,uCAAA;AAnBZ;AAwBU;;EACE,sDAAA;AArBZ;AAGM;;EAuBI,gBAAA;AAtBV;AAyBY;;EACE,cAAA;EACA,YAAA;AAtBd;AA/CE;;EA6EI,iBAAA;AA1BN;AAiCE;;EACE,gBAAA;AA9BJ;AAiCM;;EACE,wBAAA;AA9BR;AAiCM;;EACE,gCAAA;EACA,2BAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AA9BR;AAkCI;;EACE,gBAAA;EACA,WAAA;AA/BN;AA6BI;;EAKI,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;AA9BR;AAoCQ;;;;;;EACE,iBAAA;AA7BV;AAoCA;;;EACE,uBAAA;EACA,gBAAA;AAhCF;AAmCA;;;;;EAGE,kCAAA;EACA,8BAAA;EACA,iFAAA;EACA,0BAAA;EACA,sBAAA;AA/BF;AAiCE;;;;;EACE,0GAAA;EAIA,aAAA;AA9BJ;AAgCI;;;;;;;;;;EACE,2GAAA;EAIA,aAAA;AAxBN;AA4BE;;;;;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AAtBJ;AAyBM;;;;;;;;;;;;;;;EACE,qBAAA;AATR;AAcE;;;;;;;;;;EACE,mBAAA;EACA,mBAAA;EACA,kFAAA;EACA,sBAAA;AAHJ;AAME;;;;;EACE,uBAAA;AAAJ;AAGE;;;;;;;;;;EACE,sCAAA;EACA,YAAA;AAQJ;AALE;;;;;EACE,uBAAA;AAWJ;AAFE;;;;;EACE,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAQJ;AALE;;;;;EACE,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;AAWJ;AATI;;;;;;;;;;EACE,gBAAA;EACA,2BAAA;AAoBN;AAjBI;;;;;EACE,yBAAA;EACA,2BAAA;AAuBN;AArBM;;;;;;;;;;EACE,oCAAA;EACA,2BAAA;AAgCR;AA3BE;;;;;EACE,4DAAA;EACA,sBAAA;EACA,0BAAA;EACA,oEAAA;AAiCJ;AArCE;;;;;EAOI,qBAAA;EACA,kBAAA;AAqCN;AAhCA;EACE,mBAAA;EACA,aAAA;EACA,WAAA;AAkCF;AAhCE;EACE,4EAAA;AAkCJ;AA/BE;EACE,aAAA;EACA,eAAA;AAiCJ;AA9BE;EACE,UAAA;EACA,YAAA;AAgCJ;AAlCE;EAKI,mBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AAgCN;AAxCE;EAYI,eAAA;AA+BN;AA3CE;EAgBI,gBAAA;AA8BN;AA1BE;EACE,YAAA;AA4BJ;AAvBE;EACE,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,+BAAA;AAyBJ;AApCA;EAeI,oCAAA;EACA,yFAAA;AAwBJ;AAnBE;EACE,yBAAA;AAqBJ;AAvBA;EAMI,UAAA;EACA,YAAA;AAoBJ;AAfE;EACE,qCAAA;EACA,qBAAA;EACA,gBAAA;AAiBJ;AAdM;EACE,gBAAA;EACA,YAAA;EACA,qBAAA;AAgBR;AAdQ;;EACE,aAAA;AAiBV;AAdQ;EACE,yBAAA;EACA,YAAA;AAgBV;AAXI;EACE,oCAAA;AAaN;AAVQ;EACE,YAAA;AAYV;AAVU;EACE,uBAAA;EACA,cAAA;AAYZ;AAJA;EACE,mBAAA;EACA,aAAA;AAMF;AARA;EAKI,yBAAA;EACA,4BAAA;AAMJ;AAZA;EAUI,WAAA;EACA,YAAA;EACA,WAAA;AAKJ;AAHI;EACE,YAAA;AAKN;AAAA;EACE,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;AAEF;AAAE;EACE,yBAAA;EACA,kBAAA;AAEJ;AAfA;EAiBI,oCAAA;EACA,iCAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;AACJ;AAIE;EACE,qBAAA;EACA,kCAAA;AAFJ;AAMA;EACE,iBAAA;EACA,4EAAA;AAJF;AAME;EACE,2BAAA;EACA,qBAAA;AAJJ;AAMI;EACE,kBAAA;EACA,oBAAA;AAJN;AAOI;EACE,SAAA;AALN;AAQI;EACE,yBAAA;AANN;AARE;;EAkBI,qBAAA;AANN;AAZE;EAsBI,iCAAA;AAPN;AAUI;EACE,yCAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;AARN;AAaA;EACE,mBAAA;EACA,6BAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AAXF;AAaE;;EACE,6BAAA;AAVJ;AAFA;EAgBI,kBAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAcE;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AAZJ;AAeE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAbJ;AAgBE;EACE,+EAAA;EACA,yBAAA;EACA,0CAAA;EACA,uBAAA;AAdJ;AAgBI;EACE,+EAAA;EACA,yBAAA;EACA,+EAAA;EACA,uBAAA;AAdN;AAkBE;EACE,yBAAA;EACA,gBAAA;AAhBJ;AAkBI;;EACE,4BAAA;EACA,oCAAA;EACA,uFAAA;AAfN;AAkBI;EACE,gBAAA;EACA,qBAAA;AAhBN;AAkBM;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AAhBR;AAoBI;EACE,gBAAA;AAlBN;AAsBE;EACE,+BAAA;EACA,yBAAA;EACA,4DAAA;EACA,cAAA;AApBJ;AAsBI;EACE,+BAAA;EACA,yBAAA;AApBN;AAwBE;EACE,qDAAA;EACA,YAAA;EACA,0DAAA;EACA,+BAAA;AAtBJ;AAwBI;EAEI,YAAA;EACA,qBAAA;AAvBR;AA0BM;EACE,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,UAAA;AAxBR;AASI;EAmBI,eAAA;AAzBR;AAAE;EA8BI,wBAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;AA3BN;AA8BI;EACE,qDAAA;EACA,0DAAA;EACA,YAAA;EACA,+BAAA;AA5BN;AAgCE;;EACE,8DAAA;EACA,YAAA;EACA,0CAAA;EACA,YAAA;AA7BJ;AA+BI;;EAEI,qBAAA;AA7BR;AAgCM;;EACE,gBAAA;EACA,yCAAA;EACA,yBAAA;EACA,YAAA;EACA,2BAAA;EACA,0BAAA;EACA,qBAAA;AA7BR;AAiCI;;;;EACE,8DAAA;EACA,uBAAA;EACA,iFAAA;EACA,uBAAA;AA5BN;AA+BI;;EACE,wDAAA;EACA,gBAAA;EACA,oBAAA;AA5BN;AA+BI;;EACE,gCAAA;EACA,4EAAA;EACA,gBAAA;EACA,wBAAA;AA5BN;AA8BM;;EACE,4EAAA;AA3BR;AAfE;;EA+CI,uBAAA;EACA,2BAAA;EACA,sBAAA;AA5BN;AAgCE;EACE,8DAAA;AA9BJ;AAgCI;;EACE,8DAAA;EACA,gFAAA;AA7BN;AAiCE;EAEI,WAAA;EACA,oBAAA;EACA,UAAA;AAhCN;AArKA;EA0MI,qBAAA;EACA,qBAAA;AAlCJ;AAzKA;EA8MM,qBAAA;EACA,sBAAA;AAlCN;AAqCI;EACE,kBAAA;AAnCN;AAyCE;EACE,gBAAA;EACA,qBAAA;AAvCJ;AAyCI;EACE,cAAA;EACA,gBAAA;AAvCN;AA4CA;EAEI,yBAAA;EACA,qBAAA;EACA,YAAA;AA3CJ;AAuCA;EAOM,mBAAA;AA3CN;AAkDI;EACE,6BAAA;EACA,sBAAA;EACA,qBAAA;AAhDN;AA6CI;EAMI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AAhDR;AAsCI;EAcI,qBAAA;EACA,SAAA;AAjDR;AAqDI;EACE,6BAAA;AAnDN;AAuDM;EACE,yBAAA;AArDR;AA2DA;EACE,kBAAA;AAzDF;AA8DQ;EACE,yCAAA;AA5DV;AAwDE;EASM,yCAAA;EACA,qBAAA;EACA,wBAAA;EACA,iCAAA;EACA,kBAAA;AA9DR;AAgEQ;;EACE,WAAA;EACA,cAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AA7DV;AAgEQ;EACE,gEAAA;EACA,SAAA;AA9DV;AAiEQ;EACE,6DAAA;EACA,MAAA;AA/DV;AAqEU;EACE,6BAAA;AAnEZ;AAyEI;EACE,eAAA;AAvEN;AA2EE;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;AAzEJ;AAsEE;EAMI,gBAAA;AAzEN;AA6EM;EACE,2BAAA;EACA,8BAAA;AA3ER;AAyEM;EAKI,wBAAA;AA3EV;AA+EM;EACE,sCAAA;AA7ER;AAgFM;EACE,YAAA;AA9ER;AAiFM;EACE,iBAAA;EACA,mBAAA;EACA,iFAAA;EACA,yCAAA;AA/ER;AAiFQ;EACE,gCAAA;EACA,kFAAA;EACA,kBAAA;AA/EV;AA4EQ;EAMI,8BAAA;EACA,+BAAA;AA/EZ;AAqFY;EACE,gBAAA;AAnFd;AAwFQ;EACE,gCAAA;AAtFV;AAyFQ;EACE,gCAAA;AAvFV;AA0FQ;EACE,qBAAA;AAxFV;AA+FA;EACE,gBAAA;AA7FF;AA+FE;EAAA;IACE,gBAAA;EA5FF;AACF;AA+FI;EAAA;IACE,gBAAA;EA5FJ;AACF;AAgGI;EAAA;IACE,sCAAA;IACA,mGAAA;IAGA,gCAAA;EA/FJ;AACF;AAkGE;EACE,2BAAA;AAhGJ;AAmGM;EAAA;IACE,iGAAA;EAhGN;AACF;AAsGE;EACE,0BAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;AApGJ;AAuGE;EACE,gBAAA;EACA,WAAA;EACA,OAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;AArGJ;AAyGI;EACE,aAAA;EACA,cAAA;AAvGN;AA4GA;EACE,qCAAA;EACA,yBAAA;EACA,gCAAA;AA1GF;AA6GI;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;AA3GN;AA8GI;EACE,aAAA;AA5GN;AAgHE;;;;EACE,iBAAA;AA3GJ;AA8GE;EACE,0BAAA;AA5GJ;AA+GE;EACE,0BAAA;AA7GJ;AAgHE;EACE,0BAAA;AA9GJ;AAiHE;EACE,0BAAA;AA/GJ;AAmHA;EACE,iBAAA;EACA,oBAAA;EACA,kFAAA;AAjHF;AAmHE;EAAA;IACE,gBAAA;IACA,iBAAA;IACA,kBAAA;EAhHF;AACF;AAkHE;;;;EAGM,gBAAA;EACA,mBAAA;EACA,oBAAA;AA/GR;AAoHE;;EAGM,yBAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;AAnHR;AAqHQ;;EACE,2BAAA;AAlHV;AAqHQ;;EACE,2BAAA;AAlHV;AAwHE;EAGM,qBAAA;EACA,eAAA;AAxHR;AA2HM;EAEI,yBAAA;EACA,eAAA;AA1HV;AA8HM;EACE,mBAAA;AA5HR;AAiIE;;EAEI,yBAAA;AA/HN;AAmIE;EACE,oBAAA;AAjIJ;AAoIE;EACE,yBAAA;EACA,0BAAA;EACA,kBAAA;AAlIJ;AAoII;;EACE,0DAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AAjIN;AAoII;EACE,WAAA;EACA,eAAA;AAlIN;AAqII;EACE,cAAA;EACA,cAAA;AAnIN;AAyIE;EACE,qBAAA;EACA,gBAAA;EACA,sBAAA;AAvIJ;AA4IE;EAAA;IACE,eAAA;EAzIF;AACF;AA2IE;EACE,2BAAA;AAzIJ;AA+II;EAAA;IACE,4BAAA;EA5IJ;AACF;AAgJA;;EAEI,iBAAA;EACA,+BAAA;AA9IJ;AAkJA;EACE,kBAAA;EACA,gBAAA;EACA,QAAA;EACA,sCAAA;EACA,UAAA;AAhJF;AAkJE;EACE,mCAAA;AAhJJ;AAmJE;EACE,sCAAA;AAjJJ;AAqJA;EACE,wBAAA;AAnJF;AAuJE;EACE,kBAAA;AArJJ;AAwJE;EAEI,cAAA;EACA,oBAAA;EACA,yBAAA;AAvJN;AA2JE;EAEI,aAAA;EACA,oBAAA;AA1JN;AA+JA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;AA7JF;AA+JE;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;AA7JJ;AA+JI;EACE,WAAA;AA7JN;AAiKE;EACE,iBAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;AA/JJ;AAkKE;EACE,2BAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,SAAA;AAhKJ;AAqKM;EACE,gCAAA;EACA,sBAAA;AAnKR;AAyKA;EACE,4EAAA;EACA,kBAAA;AAvKF;AA0KA;EACE,aAAA;EACA,yBAAA;AAxKF;AA2KA;EACE,kBAAA;AAzKF;AA2KE;;EACE,oBAAA;EACA,sBAAA;EACA,0CAAA;EACA,UAAA;AAxKJ;AA4KI;;EACE,UAAA;AAzKN;AA4KI;EACE,mCAAA;AA1KN;AA6KI;EACE,iCAAA;AA3KN;AA+KE;EACE,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mCAAA;EACA,+BAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;AA7KJ;AAgLE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,oCAAA;EACA,qEAAA;AA9KJ","sourcesContent":["@import (css) '~antd/dist/reset.css';\n@import (css) '~feathers-react/dist/style.css';\n@font-size-base: 14px;\n@body-background: #f5f8fd;\n@font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n@primary-color: #4B4DF1;\n@success-color: #9CCC65;\n@warning-color: #FFCA28;\n@error-color: #F44336;\n@info-color: #42A5F5;\n\n@shadow-primary: ~\"0 4px 12px 0 rgba(74,144,226,0.08), 0 1px 2px 0 rgba(0,0,0,0.10)\";\n@shadow-hover: ~\"0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15)\";\n\n:root {\n  font-size: 16px;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n}\n\nbody {\n  background-color: @body-background;\n}\n\nh1, h2, h3 {\n  font-family: 'Inter', sans-serif;\n  color: #617C9D;\n  font-weight: 700;\n}\n\nh2, h3 {\n  font-weight: 400;\n}\n\nbody, h4, h5, h6, p {\n  font-family: @font-family;\n}\n\n.ReactModal {\n  &__Content {\n    background-color: @body-background !important;\n  }\n\n  &__Body--open {\n    overflow: hidden;\n  }\n}\n\nsvg {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ant-picker {\n  width: 100%;\n}\n\n.ant-menu {\n  &-inline-collapsed {\n    width: auto;\n\n    > .ant-menu-submenu > .ant-menu-submenu-title {\n      padding: 0 !important;\n    }\n  }\n\n  // Sidebar styles only — scoped to inline (and inline-collapsed) so they\n  // don't leak into vertical menus rendered inside popovers/dropdowns.\n  &-inline, &-inline-collapsed {\n    background: none;\n    border: none;\n\n    > .ant-menu-item-divider {\n      background: none;\n      margin: 1rem 0;\n    }\n\n    .ant-menu {\n      &-item {\n        color: #8282A1;\n        font-size: 1.25em;\n        font-weight: 400;\n        height: auto;\n        line-height: 2.5;\n        padding: 0 !important;\n\n        &-selected {\n          background: none !important;\n          color: @primary-color;\n\n          &::after {\n            display: none;\n          }\n        }\n\n        &:active {\n          background: none;\n        }\n\n        &:empty {\n          display: none;\n        }\n      }\n\n      &-sub {\n        font-size: 0.8em;\n        padding-left: 3.75em;\n      }\n\n      &-submenu {\n        &-title {\n          color: #8282A1;\n          font-size: 1.25em;\n          font-weight: 400;\n          height: auto;\n          line-height: 2.5;\n          padding: 0 !important;\n\n          &::after {\n            right: 0;\n            top: 50%;\n            transform: translateY(-50%) scale(0.75);\n          }\n        }\n\n        &-open {\n          &.ant-menu-submenu-inline > .ant-menu-submenu-title::after {\n            transform: translateY(-50%) rotate(180deg) scale(0.75);\n          }\n        }\n\n        > .ant-menu {\n          background: none;\n\n          .ant-menu {\n            &-item {\n              line-height: 2;\n              height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    svg {\n      margin-right: 1em;\n    }\n  }\n\n}\n\n.ant-form, .ant-legacy-form {\n  &-item {\n    text-align: left;\n\n    &-required {\n      &::before {\n        display: none !important;\n      }\n\n      &::after {\n        display: inline-block !important;\n        margin-left: 4px !important;\n        content: \"*\" !important;\n        font-family: SimSun;\n        line-height: 1;\n        font-size: 14px;\n        color: @error-color;\n      }\n    }\n\n    &-label {\n      text-align: left;\n      width: 100%;\n\n      label {\n        color: #848A9E;\n        text-transform: uppercase;\n        font-size: 0.9em;\n        letter-spacing: 0.1em;\n        font-weight: 300;\n      }\n    }\n\n    &-control {\n      &.has-success, &.has-error, &.has-warning {\n        &::after {\n          line-height: 3rem;\n        }\n      }\n    }\n  }\n}\n\n.ant-input-affix-wrapper .ant-input, .ant-input-affix-wrapper .ant-input:hover, .ant-input-affix-wrapper .ant-input:focus{\n  height: auto !important;\n  box-shadow: none;\n}\n\n.ant-input,\n.ant-input-number, .ant-picker, .ant-select,\n.ant-input-affix-wrapper {\n  background-color: white !important;\n  border-color: white !important;\n  box-shadow: 0 4px 12px 0 rgba(74,144,226,0.08), 0 1px 2px 0 rgba(0,0,0,0.10);\n  height: 2.25rem !important;\n  border-radius: .25rem;\n\n  &:-webkit-autofill {\n    box-shadow:\n      0 4px 12px 0 rgba(74,144,226,0.08),\n      0 1px 2px 0 rgba(0,0,0,0.10),\n      inset 0 0 0 500px white;\n    outline: none;\n\n    &:focus, &:hover {\n      box-shadow:\n        0 4px 12px 0 rgba(73,141,225,0.15),\n        0 1px 2px 0 rgba(0,0,0,0.15),\n        inset 0 0 0 500px white;\n      outline: none;\n    }\n  }\n\n  &-number {\n    align-items: center;\n    display: flex;\n    width: auto;\n\n    &-handler {\n      &-wrap, &-up, &-down {\n        border-color: @body-background;\n      }\n    }\n  }\n\n  &:focus, &:hover {\n    background: #FFFFFF;\n    border-color: white;\n    box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);\n    border-radius: .25rem;\n  }\n\n  &-lg {\n    height: 3rem !important;\n  }\n\n  &[disabled], &-disabled {\n    border: 1px dashed rgba(0, 0, 0, .05);\n    opacity: .5;\n  }\n\n  .ant-input-group-lg & {\n    height: 3rem !important;\n  }\n\n  // .ant-input-affix-wrapper & {\n  //   &:not(:first-child) {\n  //     padding-left: 2.5rem;\n  //   }\n  // }\n\n  &--focus-only:not(:focus) {\n    background: none;\n    border-color: transparent;\n    box-shadow: none;\n    cursor: pointer;\n    padding: 0;\n  }\n\n  &--flat {\n    border-radius: 0;\n    box-shadow: 0 1px 0 #F2F2F2;\n    padding-left: 0;\n    padding-right: 0;\n\n    &:hover, &:focus {\n      border-radius: 0;\n      box-shadow: 0 1px 0 @primary-color;\n    }\n\n    .has-error & {\n      border-color: transparent;\n      box-shadow: 0 1px 0 #F2F2F2;\n\n      &:hover, &:focus {\n        border-color: transparent !important;\n        box-shadow: 0 1px 0 @primary-color;\n      }\n    }\n  }\n\n  &--password-confirm {\n    mask-image: linear-gradient(to left, transparent, white 4em);\n    padding: .75em .25em;\n    transform: translateX(4em);\n    -webkit-mask-image: linear-gradient(to left, transparent, white 4em);\n\n    .ant-input {\n      border-radius: 1.75em;\n      padding-right: 4em;\n    }\n  }\n}\n\n.ant-select {\n  align-items: center;\n  display: flex;\n  width: 100%;\n\n  &-focused {\n    box-shadow: @shadow-hover;\n  }\n\n  &-content {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  &-multiple {\n    padding: 0;\n    height: auto;\n\n    .ant-select-content {\n      align-items: center;\n      display: flex;\n      height: inherit;\n      margin: 0;\n    }\n\n    .ant-select-selection-item {\n      margin: .125em;\n    }\n\n    .ant-select-placeholder {\n      padding: 0 .5em;\n    }\n  }\n\n  &-lg {\n    height: 3rem;\n  }\n}\n\n.ant-badge {\n  &-count {\n    background-color: @primary-color;\n    cursor: default;\n    font-size: 0.75em;\n    height: 1rem;\n    min-width: 1rem;\n    line-height: 1rem;\n    padding: 0 .25rem;\n    right: 0;\n    top: 0;\n    transform: translate(25%, -25%);\n  }\n\n  .ant-btn-flat:not(:only-child):not(:hover) {\n    background: rgba(255, 255, 255, .5);\n    box-shadow: rgba(50, 50, 93, .05) 0 .0625rem .25rem, rgba(0, 0, 0, .02) 0 .0625rem 0;\n  }\n}\n\n.ant-input-affix-wrapper {\n  &:hover .ant-input:not(.ant-input-disabled) {\n    border-color: transparent;\n  }\n\n  .ant-input-prefix {\n    left: 1rem;\n    opacity: .5;\n  }\n}\n\n.ant-radio {\n  &-group {\n    background-color: rgba(0, 0, 0, .05);\n    border-radius: 1.25em;\n    padding: .125em;\n\n    .ant-radio {\n      &-button-wrapper {\n        background: none;\n        border: none;\n        border-radius: 1.25em;\n\n        &::before, &::after {\n          display: none;\n        }\n\n        &-checked {\n          background-color: @primary-color;\n          color: white;\n        }\n      }\n    }\n\n    &--inverted {\n      background-color: rgba(0, 0, 0, .1);\n\n      .ant-radio {\n        &-button-wrapper {\n          color: white;\n\n          &-checked {\n            background-color: white;\n            color: @primary-color;\n          }\n        }\n      }\n    }\n  }\n}\n\n.ant-input-group {\n  align-items: center;\n  display: flex;\n\n  .ant-btn:last-child {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .ant-input {\n    float: none;\n    flex-grow: 1;\n    width: auto;\n\n    &-group-addon {\n      flex-grow: 1;\n    }\n  }\n}\n\n.ant-tag {\n  align-items: center;\n  background-color: #DBE8F9;\n  border: none;\n  border-radius: .8rem;\n  display: inline-flex;\n  height: 1.625rem;\n  line-height: 1;\n  margin: .25rem .5rem .25rem 0;\n  padding: 0 .5rem;\n\n  &-text {\n    color: rgba(0, 0, 0, .5);\n    font-size: .75rem;\n  }\n\n  svg {\n    background-color: rgba(0, 0, 0, .1);\n    border: .25rem solid transparent;\n    border-radius: 50%;\n    margin-left: -.35rem;\n    margin-right: .25rem;\n  }\n}\n\n.ant-dropdown {\n  &-placement-topRight {\n    left: auto !important;\n    right: ~\"calc(25em + 7vw) !important\";\n  }\n}\n\n.ant-dropdown-menu {\n  padding: .5rem 0;\n  box-shadow: @shadow-hover;\n\n  &-item {\n    border-radius: 0 !important;\n    padding: .75rem 1rem;\n\n    &-group-title {\n      font-size: .65rem;\n      padding: 1rem 1rem 0;\n    }\n\n    &-group-list {\n      margin: 0;\n    }\n\n    &-divider {\n      background-color: #FAFAFA;\n    }\n\n    svg, i {\n      margin-right: .75rem;\n    }\n\n    svg {\n      transform: translateY(-.0625rem);\n    }\n\n    &--info {\n      background-color: fade(@primary-color, 5%);\n      color: #617C9D;\n      font-size: .85em;\n      margin-top: -.5rem;\n      padding: .25em 1.125em;\n      pointer-events: none;\n    }\n  }\n}\n\n.ant-btn {\n  align-items: center;\n  background-color: transparent;\n  border-radius: 1.125rem;\n  display: inline-flex;\n  font-size: .75rem;\n  justify-content: center;\n  min-height: 2.25rem;\n  padding: 0 1rem;\n  text-transform: uppercase;\n\n  &:hover, &:focus {\n    background-color: transparent;\n  }\n\n  > .anticon {\n    font-size: 1.125em;\n    margin-right: .5em;\n    display: block;\n  }\n\n  &-sm {\n    border-radius: 1rem;\n    min-height: 2rem;\n    padding: 0 .75rem;\n  }\n\n  &-lg {\n    border-radius: 1.5rem;\n    font-size: 1rem;\n    font-weight: 300;\n    min-height: 3rem;\n    padding: 0 1.5rem;\n  }\n\n  &-danger {\n    background-image: linear-gradient(to bottom right, #F44336, #F4367C) !important;\n    border-color: transparent;\n    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.10);\n    color: white !important;\n\n    &:hover {\n      background-image: linear-gradient(to bottom right, #F44336, #F4367C) !important;\n      border-color: transparent;\n      box-shadow: 0 1px 2px 0 rgba(0,0,0,0.10), 0 2px 16px 0 rgba(244,67,54,0.20);\n      color: white !important;\n    }\n  }\n\n  &-flat {\n    border-color: transparent;\n    box-shadow: none;\n\n    &:hover, &:focus {\n      background: white !important;\n      border-color: transparent !important;\n      box-shadow: @shadow-hover !important;\n    }\n\n    &[disabled] {\n      background: none;\n      border-color: #d0d0d0;\n\n      &:hover {\n        background: none;\n        border-color: #d0d0d0;\n        box-shadow: none;\n      }\n    }\n\n    & + & {\n      margin-left: 1em;\n    }\n  }\n\n  &-pressed {\n    background: rgba(0, 0, 0, .05);\n    border-color: transparent;\n    box-shadow: inset 0 .0625rem .0625rem rgba(0, 0, 0, .125);\n    color: @primary-color;\n\n    &:hover {\n      background: rgba(0, 0, 0, .05);\n      border-color: transparent;\n    }\n  }\n\n  &-pressed-primary {\n    background: linear-gradient(to top, darken(#4AC385, 5%), darken(#4AC385, 10%));\n    border: none;\n    box-shadow: inset 0 .0625rem .125rem rgba(0, 0, 0, .25);\n    color: rgba(255, 255, 255, .9);\n\n    &[data-close-text] {\n      span:last-child {\n        font-size: 0;\n        transition: all 500ms;\n      }\n\n      &::before {\n        background: none;\n        content: attr(data-close-text) !important;\n        display: block !important;\n        font-size: .8rem;\n        margin-right: 1em;\n        opacity: 1;\n        position: static;\n        transition: all 500ms;\n        z-index: 2;\n      }\n\n      svg {\n        margin-right: 0;\n      }\n    }\n\n    .icon-plus {\n      transform: rotate(45deg);\n      transition: transform 250ms;\n      transition-delay: 125ms;\n      will-change: transform;\n    }\n\n    &:hover {\n      background: linear-gradient(to top, darken(#4AC385, 5%), darken(#4AC385, 10%));\n      box-shadow: inset 0 .0625rem .125rem rgba(0, 0, 0, .25);\n      border: none;\n      color: rgba(255, 255, 255, .9);\n    }\n  }\n\n  &-primary:not(.ant-btn-background-ghost), &-primary-alt {\n    background: linear-gradient(to bottom right, #81E390, #4AC385);\n    border: none;\n    box-shadow: 0 1px 2px 0 rgba(0,0,0,0.10);\n    color: white;\n\n    &[data-close-text] {\n      span:last-child {\n        transition: all 500ms;\n      }\n\n      &::before {\n        background: none;\n        content: attr(data-close-text) !important;\n        display: block !important;\n        font-size: 0;\n        position: static !important;\n        transform: none !important;\n        transition: all 500ms;\n      }\n    }\n\n    &:hover, &:focus {\n      background: linear-gradient(to bottom right, #81E390, #4AC385);\n      border: none !important;\n      box-shadow: 0 1px 3px 0 rgba(0,0,0,0.10), 0 2px 16px 0 rgba(139,195,74,0.25);\n      color: white !important;\n    }\n\n    &[disabled] {\n      background: linear-gradient(to bottom right, #EEE, #DDD);\n      box-shadow: none;\n      pointer-events: none;\n    }\n\n    .ant-input-group-lg & {\n      border-radius: 0 1.5rem 1.5rem 0;\n      box-shadow: @shadow-primary;\n      min-height: 3rem;\n      padding: 0 2rem 0 1.5rem;\n\n      &:hover {\n        box-shadow: @shadow-hover;\n      }\n    }\n\n    .icon-plus {\n      transition-delay: 125ms;\n      transition: transform 250ms;\n      will-change: transform;\n    }\n  }\n\n  &-primary-alt {\n    background: linear-gradient(to bottom right, lighten(@primary-color, 15%), @primary-color);\n\n    &:focus, &:hover {\n      background: linear-gradient(to bottom right, lighten(@primary-color, 15%), @primary-color);\n      box-shadow: 0 1px 3px 0 rgba(0,0,0,0.10), 0 2px 16px 0 rgba(96, 74, 195, 0.25);\n    }\n  }\n\n  &-loading {\n    .anticon-loading {\n      height: 1em;\n      margin-right: .25em;\n      width: 1em;\n    }\n  }\n\n  svg {\n    margin-right: .75rem;\n    margin-left: -.25rem;\n\n    + span {\n      margin-left: -.25rem;\n      vertical-align: middle;\n    }\n\n    &:only-child {\n      margin: 0 -.35rem;\n    }\n  }\n}\n\n.ant-card {\n  &-head {\n    background: none;\n    border-color: #FAFAFA;\n\n    &-title {\n      color: @primary-color;\n      font-weight: 300;\n    }\n  }\n}\n\n.ant-steps-status-warn {\n  .ant-steps-item-icon {\n    background-color: @warning-color;\n    border-color: darken(@warning-color, 10%);\n    color: white;\n\n    .ant-steps-icon {\n      color: currentColor;\n    }\n  }\n}\n\n.ant-steps:not(.ant-steps-horizontal) {\n  .ant-steps {\n    &-item-icon {\n      background-color: transparent;\n      height: 2em !important;\n      width: 2em !important;\n\n      > .ant-steps-icon {\n        align-items: center;\n        display: flex;\n        height: 100%;\n        justify-content: center;\n        width: 100%;\n      }\n\n      svg {\n        display: inline-block;\n        margin: 0;\n      }\n    }\n\n    &-title {\n      background-color: transparent;\n    }\n\n    &-description {\n      &::first-letter {\n        text-transform: uppercase;\n      }\n    }\n  }\n}\n\n.ant-collapse {\n  margin-bottom: 2em;\n\n  &-borderless {\n    > .ant-collapse-item {\n      > .ant-collapse-header {\n        &:hover {\n          background-color: fade(@primary-color, 5%);\n        }\n      }\n\n      > .ant-collapse-panel {\n        background-color: fade(@primary-color, 2%);\n        border-top: 1px solid;\n        border-bottom: 1px solid;\n        border-color: rgba(0, 0, 0, .05);\n        position: relative;\n\n        &::after, &::before {\n          content: '';\n          height: .25em;\n          left: 0;\n          opacity: .025;\n          position: absolute;\n          right: 0;\n        }\n\n        &::after {\n          background-image: linear-gradient(to bottom, transparent, black);\n          bottom: 0;\n        }\n\n        &::before {\n          background-image: linear-gradient(to top, transparent, black);\n          top: 0;\n        }\n      }\n\n      &-active {\n        > .ant-collapse-header {\n          &:hover {\n            background-color: transparent;\n          }\n        }\n      }\n    }\n\n    & + & {\n      margin-top: 2em;\n    }\n  }\n\n  &--cards {\n    background: none;\n    border: none;\n    border-radius: 0;\n\n    > .ant-collapse-item:not(.ant-collapse-item-disabled) > .ant-collapse-header:active {\n      background: none;\n    }\n\n    .ant-collapse {\n      &-header {\n        line-height: 2.5 !important;\n        padding-left: 2.5em !important;\n\n        .ant-collapse-arrow {\n          display: none !important;\n        }\n      }\n\n      &-panel {\n        border-top-color: rgba(0, 0, 0, .025);\n      }\n\n      &-body {\n        padding: 1em;\n      }\n\n      &-item {\n        background: white;\n        border-bottom: none;\n        box-shadow: 0 4px 12px 0 rgba(74,144,226,0.08), 0 1px 2px 0 rgba(0,0,0,0.10);\n        transition: margin 250ms, transform 250ms;\n\n        &-active {\n          border-radius: .25em !important;\n          box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);\n          margin: 1em -.5em;\n\n          + .ant-collapse-item {\n            border-top-left-radius: .25em;\n            border-top-right-radius: .25em;\n          }\n        }\n\n        &-disabled {\n          .ant-collapse {\n            &-header {\n              background: none;\n            }\n          }\n        }\n\n        &:first-child:not(.ant-collapse-item-active) {\n          border-radius: .25em .25em 0 0;\n        }\n\n        &:last-child:not(.ant-collapse-item-active) {\n          border-radius: 0 0 .25em .25em;\n        }\n\n        &:only-child:not(.ant-collapse-item-active) {\n          border-radius: .25em;\n        }\n      }\n    }\n  }\n}\n\n.ant-layout {\n  background: none;\n\n  @media (max-width: 480px) {\n    overflow: hidden;\n  }\n\n  &-content {\n    @media (max-width: 480px) {\n      min-width: 100vw;\n    }\n  }\n\n  &.ant-layout-has-sider &-sider {\n    @media (max-width: 480px) {\n      background-color: rgba(0, 0, 0, .025);\n      box-shadow:\n        inset -.125em 0 .125em rgba(0, 0, 0, .05),\n        inset -.25em 0 .5em rgba(0, 0, 0, .05);\n      min-height: ~\"calc(100vh - 4.75em)\";\n    }\n  }\n\n  &.ant-layout-has-sider.ant-layout-reversed {\n    flex-direction: row-reverse;\n\n    .ant-layout-sider {\n      @media (max-width: 480px) {\n        box-shadow:\n          inset .125em 0 .125em rgba(0, 0, 0, .05),\n          inset .25em 0 .5em rgba(0, 0, 0, .05);\n      }\n    }\n  }\n\n  .ant-layout-reversed &-sider-zero-width-trigger {\n    border-radius: 4px 0 0 4px;\n    position: fixed;\n    right: 0;\n    top: 8em;\n  }\n\n  .ant-layout-default &-sider-zero-width-trigger {\n    background: none;\n    color: #666;\n    left: 0;\n    position: fixed;\n    right: auto;\n    top: .75em;\n    z-index: 20;\n  }\n\n  .ant-layout-reversed &-sider {\n    &-collapsed {\n      max-height: 0;\n      padding: 5em 0;\n    }\n  }\n}\n\n.ant-alert {\n  border: 1px solid rgba(0, 0, 0, .05);\n  border-left-width: .25em;\n  border-radius: 0 .25em .25em 0;\n\n  &-title {\n    .ant-alert-with-description & {\n      font-size: 1.5em;\n      font-weight: 300;\n      margin-bottom: .5em;\n    }\n\n    &:empty {\n      display: none;\n    }\n  }\n\n  &-info, &-error, &-warning, &-success {\n    background: white;\n  }\n\n  &-info {\n    border-left-color: @info-color;\n  }\n\n  &-error {\n    border-left-color: @error-color;\n  }\n\n  &-warning {\n    border-left-color: @warning-color;\n  }\n\n  &-success {\n    border-left-color: @success-color;\n  }\n}\n\n.ant-table {\n  background: white;\n  border-radius: .5em;\n  box-shadow: 0 4px 12px 0 rgba(73,141,225,0.15), 0 1px 2px 0 rgba(0,0,0,0.15);\n\n  @media (max-width: 480px) {\n    border-radius: 0;\n    margin-left: -1em;\n    margin-right: -1em;\n  }\n\n  &-thead, &-tbody {\n    > tr {\n      > th, td {\n        font-size: .9em;\n        padding-left: 1.5em;\n        padding-right: 1.5em;\n      }\n    }\n  }\n\n  &-thead {\n    > tr {\n      > th, > td {\n        background-color: #FDFDFD;\n        border-bottom: 1px solid #F2F2F2;\n        color: #999;\n        font-weight: 400;\n\n        &:first-child {\n          border-radius: .26em 0 0 0;\n        }\n\n        &:last-child {\n          border-radius: 0 .26em 0 0;\n        }\n      }\n    }\n  }\n\n  &-tbody {\n    > tr {\n      > td {\n        border-color: #FAFAFA;\n        cursor: pointer;\n      }\n\n      &.ant-table-expanded-row:hover {\n        > td {\n          background-color: #FEFEFE;\n          cursor: default;\n        }\n      }\n\n      &:last-child > td {\n        border-bottom: none;\n      }\n    }\n  }\n\n  &-expanded-row, &-expanded-row:hover {\n    td {\n      background-color: #FEFEFE;\n    }\n  }\n\n  &-row-expand-icon {\n    pointer-events: none;\n  }\n\n  &-footer {\n    background-color: #FCFCFC;\n    color: rgba(0, 0, 0, .35);\n    position: relative;\n\n    &::after, &::before {\n      background: linear-gradient(to bottom, black, transparent);\n      content: '';\n      left: 0;\n      position: absolute;\n      right: 0;\n      top: 0;\n    }\n\n    &::after {\n      height: 1em;\n      opacity: .0125;\n    }\n\n    &::before {\n      height: .25em;\n      opacity: .025;\n    }\n  }\n}\n\n.ant-switch {\n  &-label {\n    display: inline-block;\n    margin-left: 1em;\n    vertical-align: middle;\n  }\n}\n\n.ant-popover {\n  @media (min-width: 768px) {\n    max-width: 25vw;\n  }\n\n  &-container {\n    box-shadow: none !important;\n  }\n}\n\n.ant-tooltip {\n  &-inner {\n    @supports (backdrop-filter: blur(.5em)) {\n      backdrop-filter: blur(.5em);\n    }\n  }\n}\n\n.ReactModal__Body--open, body[style=\"overflow: hidden;\"] {\n  #root {\n    filter: blur(5px);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.sidebar-modal {\n  position: absolute;\n  overflow-y: auto;\n  right: 0;\n  transform: translateX(100%) !important;\n  width: 50%;\n\n  &--opened {\n    transform: translateX(0) !important;\n  }\n\n  &--closing {\n    transform: translateX(100%) !important;\n  }\n}\n\n.CodeMirror {\n  height: 700px !important;\n}\n\n.recharts {\n  &-text {\n    fill: currentColor;\n  }\n\n  &-cartesian-grid {\n    line {\n      opacity: .125;\n      stroke: currentColor;\n      stroke-dasharray: .125em;\n    }\n  }\n\n  &-cartesian-axis {\n    line {\n      opacity: .25;\n      stroke: currentColor;\n    }\n  }\n}\n\n.ant-legacy-form-item .ReactPasswordStrength {\n  align-items: center;\n  border: none;\n  display: flex;\n  font-size: inherit;\n  padding-right: 2em !important;\n  position: relative;\n\n  &-input {\n    border: none;\n    flex-grow: 1;\n    font-size: inherit;\n    height: 100%;\n    padding: 0 .25em;\n    width: auto;\n\n    &::placeholder {\n      color: #999;\n    }\n  }\n\n  &-strength-desc {\n    font-size: .75em;\n    padding: 0;\n    pointer-events: none;\n    position: static;\n    white-space: nowrap;\n  }\n\n  &-strength-bar {\n    border-radius: 0 0 0 .25em;\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    top: auto;\n  }\n\n  &.is-strength-4 {\n    .ReactPasswordStrength {\n      &-strength-bar {\n        border-radius: 0 0 .25em .25em;\n        width: 100% !important;\n      }\n    }\n  }\n}\n\n.fr-table-wrapper {\n  box-shadow: @shadow-primary;\n  font-size: 1.125em;\n}\n\n.fr-table-content {\n  hyphens: auto;\n  overflow-wrap: break-word;\n}\n\n[data-tooltip]:not([data-tooltip=\"\"]) {\n  position: relative;\n\n  &::before, &::after {\n    pointer-events: none;\n    will-change: transform;\n    transition: transform 250ms, opacity 250ms;\n    opacity: 0;\n  }\n\n  &:hover {\n    &::before, &::after {\n      opacity: 1;\n    }\n\n    &::before {\n      transform: translate(-50%, -0.5rem);\n    }\n\n    &::after {\n      transform: translate(-50%, -1rem);\n    }\n  }\n\n  &::after {\n    content: ~\"attr(data-tooltip)\";\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translate(-50%, -0.5rem);\n    background: rgba(0, 0, 0, 0.75);\n    padding: 0.5rem 0.75rem;\n    border-radius: 0.25rem;\n    color: white;\n    z-index: 100;\n    text-transform: none;\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;\n    transform: translate(-50%, 0);\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0.5rem 0.5rem 0 0.5rem;\n    border-color: rgba(0, 0, 0, 0.75) transparent transparent transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
